import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PRODUCT_NAME } from "../lib/brand";
import Footer from "./Footer";
import { Logo } from "./Logo";
import { ColorModeToggle } from "./ColorModeToggle";

// The shell the legal pages share.
//
// Deliberately outside <Layout>: Terms and Privacy have to be readable by
// someone who is not signed in -- a prospective customer reading them before
// they hand over a card, or a regulator -- so they cannot sit behind the
// dashboard chrome.
export default function LegalPage({
  title,
  effective,
  children
}: {
  title: string;
  effective: string;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="border-b border-slate-200 bg-surface">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <Link to="/" aria-label={`${PRODUCT_NAME} home`} className="flex">
            <Logo />
          </Link>
          <ColorModeToggle />
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10">
        <h1 className="text-3xl font-semibold text-slate-900">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">Effective {effective}</p>
        <div className="mt-8 space-y-8">{children}</div>
      </main>

      <Footer />
    </div>
  );
}

export function Section({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-lg font-medium text-slate-900">{heading}</h2>
      <div className="mt-2 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
    </section>
  );
}
